/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';

import { ValidationErrorFieldsFragmentDoc } from '../../../graphql/fragments/ValidationErrorFields.generated';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AllergenPropertyKind =
  | 'CRUSTACEAN_SHELLFISH'
  | 'EGGS'
  | 'FISH'
  | 'MEAT'
  | 'MILK'
  | 'PEANUTS'
  | 'SESAME'
  | 'SOYBEANS'
  | 'TREE_NUTS'
  | 'WHEAT';

/** The cost of the product may vary depending on the channel of the order. Use DELIVERY_COST_CHANNEL if the current order is delivery, and DEFAULT_COST_CHANNEL otherwise. Marketplace and Outpost cost channels are implicit based on the request and restaurant. */
export type CostChannel = 'DEFAULT_COST_CHANNEL' | 'DELIVERY_COST_CHANNEL' | 'PICKUP_COST_CHANNEL';

export type DietaryPropertyKind = 'DAIRY' | 'FISH' | 'GLUTEN' | 'MEAT' | 'NUTS' | 'SOY';

export type DressingMode = 'MIXED' | 'NOT_DRESSABLE' | 'ON_THE_SIDE' | 'REMOVED';

export type DressingWeight = 'HEAVY' | 'LIGHT' | 'MEDIUM';

export type IngredientKind = 'BASE' | 'DRESSING' | 'PREMIUM' | 'TOPPING';

export type LineItemBySlugInput = {
  readonly slug: string | number;
};

export type LocationByAddressIdInput = {
  /** id for an address present in the current session. */
  readonly addressId: string | number;
  readonly useCartRestaurant?: boolean | null | undefined;
};

/** The version of modifier group structure to return. v1 returns legacy flat groups, v2 returns included pricing split groups. */
export type ModifierGroupVersion = 'v1' | 'v2';

export type ModifierType = 'ADDITION' | 'INCLUDED' | 'MIXED_DRESSING' | 'REMOVAL' | 'SUBSTITUTION';

export type GetSharedLineItemQueryVariables = Exact<{
  input: Types.LineItemBySlugInput;
}>;

export type GetSharedLineItemQuery = {
  readonly lineItemBySlug:
    | { readonly __typename: 'LineItemNotFound'; readonly message: string; readonly status: number }
    | {
        readonly __typename: 'LineItemSuccess';
        readonly lineItem: {
          readonly __typename: 'LineItem';
          readonly id: string;
          readonly slug: string;
          readonly quantity: number;
          readonly calories: number;
          readonly perItemCost: number;
          readonly customName: string | null;
          readonly customerName: string;
          readonly isCustom: boolean;
          readonly dressingMode: Types.DressingMode;
          readonly product: {
            readonly __typename: 'Product';
            readonly id: string;
            readonly name: string;
            readonly slug: string;
            readonly calories: number;
            readonly cost: number;
            readonly isCustom: boolean;
            readonly enableDressingDetails: boolean;
            readonly description: string;
            readonly baseProduct: {
              readonly __typename: 'BaseProduct';
              readonly id: string;
              readonly slug: string;
              readonly lineageKey: string | null;
            };
            readonly label: {
              readonly __typename: 'ProductLabel';
              readonly id: string;
              readonly name: string;
            } | null;
            readonly asset: { readonly url: string };
            readonly allergenProperties: ReadonlyArray<{
              readonly __typename: 'AllergenProperty';
              readonly id: string;
              readonly name: Types.AllergenPropertyKind;
            }>;
            readonly ingredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
            }>;
            readonly dietaryProperties: ReadonlyArray<{
              readonly __typename: 'DietaryProperty';
              readonly id: string;
              readonly name: Types.DietaryPropertyKind;
            }>;
            readonly restaurant: {
              readonly __typename: 'Restaurant';
              readonly id: string;
              readonly slug: string;
              readonly name: string;
            };
          };
          readonly mixedDressingDetails: ReadonlyArray<{
            readonly __typename: 'MixedDressingDetails';
            readonly ingredientId: string;
            readonly weight: Types.DressingWeight;
          }>;
          readonly ingredients: ReadonlyArray<{
            readonly __typename: 'Ingredient';
            readonly id: string;
            readonly name: string;
            readonly totalFatG: number | null;
            readonly totalCarbsG: number | null;
            readonly proteinG: number | null;
            readonly dietaryFiberG: number | null;
            readonly asset: { readonly url: string };
          }>;
          readonly selectedModifiers: ReadonlyArray<{
            readonly __typename: 'SelectedModifier';
            readonly id: number;
            readonly modifierType: Types.ModifierType | null;
            readonly cost: number;
            readonly parentId: number | null;
            readonly ingredient: {
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
            } | null;
          }>;
        };
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{ readonly field: string; readonly message: string }>;
      }
    | null;
};

export type GetSharedLineItemProductModifierGroupsQueryVariables = Exact<{
  id: string | number;
  modifierGroupVersion?: Types.ModifierGroupVersion | null | undefined;
}>;

export type GetSharedLineItemProductModifierGroupsQuery = {
  readonly product: {
    readonly __typename: 'Product';
    readonly modifierGroups: ReadonlyArray<{
      readonly __typename: 'ModifierGroup';
      readonly displayName: string;
      readonly modifications: ReadonlyArray<{
        readonly __typename: 'IngredientModifier';
        readonly ingredient: { readonly __typename: 'Ingredient'; readonly id: string } | null;
      }>;
    }>;
  };
};

export type GetSharedLineItemProductForRestaurantQueryVariables = Exact<{
  baseProductSlug: string;
  restaurantId: string;
  costChannel?: Types.CostChannel | null | undefined;
}>;

export type GetSharedLineItemProductForRestaurantQuery = {
  readonly productForRestaurant: {
    readonly __typename: 'Product';
    readonly id: string;
    readonly slug: string;
    readonly name: string;
    readonly isModifiable: boolean;
    readonly outOfStock: boolean;
    readonly cost: number;
    readonly restaurant: {
      readonly __typename: 'Restaurant';
      readonly id: string;
      readonly slug: string;
      readonly name: string;
    };
  } | null;
};

export type GetSharedLineItemProductForRestaurantByLineageKeyQueryVariables = Exact<{
  lineageKey: string;
  restaurantId: string;
  costChannel?: Types.CostChannel | null | undefined;
}>;

export type GetSharedLineItemProductForRestaurantByLineageKeyQuery = {
  readonly productForRestaurantByLineageKey: {
    readonly __typename: 'Product';
    readonly id: string;
    readonly slug: string;
    readonly name: string;
    readonly isModifiable: boolean;
    readonly outOfStock: boolean;
    readonly cost: number;
    readonly restaurant: {
      readonly __typename: 'Restaurant';
      readonly id: string;
      readonly slug: string;
      readonly name: string;
    };
  } | null;
};

export type GetSharedLineItemRestaurantQueryVariables = Exact<{
  id: string | number;
}>;

export type GetSharedLineItemRestaurantQuery = {
  readonly restaurant: {
    readonly __typename: 'Restaurant';
    readonly id: string;
    readonly slug: string;
    readonly name: string;
    readonly isOutpost: boolean;
    readonly address: string;
    readonly city: string;
    readonly state: string;
    readonly zipCode: string;
  } | null;
};

export type GetSharedLineItemDeliveryLocationQueryVariables = Exact<{
  input: Types.LocationByAddressIdInput;
  addressId: string | number;
}>;

export type GetSharedLineItemDeliveryLocationQuery = {
  readonly address: {
    readonly __typename: 'Address';
    readonly id: string;
    readonly name: string | null;
    readonly street: string;
    readonly secondaryStreet: string | null;
    readonly city: string;
    readonly state: string;
    readonly zipCode: string;
  } | null;
  readonly locationByAddressId:
    | { readonly __typename: 'InvalidInput' }
    | {
        readonly __typename: 'Location';
        readonly restaurant: {
          readonly __typename: 'Restaurant';
          readonly id: string;
          readonly slug: string;
          readonly name: string;
          readonly deliveryFee: number;
        };
        readonly vendor: { readonly name: string; readonly restaurantId: string };
      }
    | { readonly __typename: 'NoValidRestaurants' }
    | { readonly __typename: 'ValidationError' };
};

export const GetSharedLineItemDocument = gql`
  query GetSharedLineItem($input: LineItemBySlugInput!) {
    lineItemBySlug(input: $input) {
      __typename
      ... on LineItemSuccess {
        lineItem {
          id
          __typename
          slug
          quantity
          calories
          perItemCost
          customName
          customerName
          isCustom
          product {
            id
            __typename
            name
            slug
            calories
            cost
            isCustom
            enableDressingDetails
            baseProduct {
              id
              __typename
              slug
              lineageKey
            }
            label {
              id
              __typename
              name
            }
            description
            asset {
              url
            }
            allergenProperties {
              id
              __typename
              name
            }
            ingredients {
              id
              __typename
              name
              kind
            }
            dietaryProperties {
              id
              __typename
              name
            }
            restaurant {
              id
              __typename
              slug
              name
            }
          }
          dressingMode
          mixedDressingDetails {
            __typename
            ingredientId
            weight
          }
          ingredients {
            __typename
            id
            name
            asset {
              url
            }
            totalFatG
            totalCarbsG
            proteinG
            dietaryFiberG
          }
          selectedModifiers {
            id
            __typename
            modifierType
            cost
            parentId
            ingredient {
              id
              __typename
              name
              kind
            }
          }
        }
      }
      ... on LineItemNotFound {
        message
        status
      }
      ...ValidationErrorFields
    }
  }
  ${ValidationErrorFieldsFragmentDoc}
`;

export function useGetSharedLineItemQuery(
  options: Omit<Urql.UseQueryArgs<GetSharedLineItemQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetSharedLineItemQuery, GetSharedLineItemQueryVariables>({
    query: GetSharedLineItemDocument,
    ...options,
  });
}
export const GetSharedLineItemProductModifierGroupsDocument = gql`
  query GetSharedLineItemProductModifierGroups(
    $id: ID!
    $modifierGroupVersion: ModifierGroupVersion
  ) {
    product(id: $id) {
      __typename
      modifierGroups(version: $modifierGroupVersion) {
        __typename
        displayName
        modifications {
          __typename
          ingredient {
            __typename
            id
          }
        }
      }
    }
  }
`;

export function useGetSharedLineItemProductModifierGroupsQuery(
  options: Omit<Urql.UseQueryArgs<GetSharedLineItemProductModifierGroupsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    GetSharedLineItemProductModifierGroupsQuery,
    GetSharedLineItemProductModifierGroupsQueryVariables
  >({ query: GetSharedLineItemProductModifierGroupsDocument, ...options });
}
export const GetSharedLineItemProductForRestaurantDocument = gql`
  query GetSharedLineItemProductForRestaurant(
    $baseProductSlug: String!
    $restaurantId: String!
    $costChannel: CostChannel
  ) {
    productForRestaurant(baseProductSlug: $baseProductSlug, restaurantId: $restaurantId) {
      __typename
      id
      slug
      name
      cost: channelCost(costChannel: $costChannel)
      isModifiable
      outOfStock
      restaurant {
        __typename
        id
        slug
        name
      }
    }
  }
`;

export function useGetSharedLineItemProductForRestaurantQuery(
  options: Omit<Urql.UseQueryArgs<GetSharedLineItemProductForRestaurantQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    GetSharedLineItemProductForRestaurantQuery,
    GetSharedLineItemProductForRestaurantQueryVariables
  >({ query: GetSharedLineItemProductForRestaurantDocument, ...options });
}
export const GetSharedLineItemProductForRestaurantByLineageKeyDocument = gql`
  query GetSharedLineItemProductForRestaurantByLineageKey(
    $lineageKey: String!
    $restaurantId: String!
    $costChannel: CostChannel
  ) {
    productForRestaurantByLineageKey(lineageKey: $lineageKey, restaurantId: $restaurantId) {
      __typename
      id
      slug
      name
      cost: channelCost(costChannel: $costChannel)
      isModifiable
      outOfStock
      restaurant {
        __typename
        id
        slug
        name
      }
    }
  }
`;

export function useGetSharedLineItemProductForRestaurantByLineageKeyQuery(
  options: Omit<
    Urql.UseQueryArgs<GetSharedLineItemProductForRestaurantByLineageKeyQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    GetSharedLineItemProductForRestaurantByLineageKeyQuery,
    GetSharedLineItemProductForRestaurantByLineageKeyQueryVariables
  >({ query: GetSharedLineItemProductForRestaurantByLineageKeyDocument, ...options });
}
export const GetSharedLineItemRestaurantDocument = gql`
  query GetSharedLineItemRestaurant($id: ID!) {
    restaurant(id: $id) {
      __typename
      id
      slug
      name
      isOutpost
      address
      city
      state
      zipCode
    }
  }
`;

export function useGetSharedLineItemRestaurantQuery(
  options: Omit<Urql.UseQueryArgs<GetSharedLineItemRestaurantQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetSharedLineItemRestaurantQuery, GetSharedLineItemRestaurantQueryVariables>(
    { query: GetSharedLineItemRestaurantDocument, ...options },
  );
}
export const GetSharedLineItemDeliveryLocationDocument = gql`
  query GetSharedLineItemDeliveryLocation($input: LocationByAddressIdInput!, $addressId: ID!) {
    address(addressId: $addressId) {
      __typename
      id
      name
      street
      secondaryStreet
      city
      state
      zipCode
    }
    locationByAddressId(input: $input) {
      __typename
      ... on Location {
        restaurant {
          __typename
          id
          slug
          name
          deliveryFee
        }
        vendor {
          name
          restaurantId
        }
      }
    }
  }
`;

export function useGetSharedLineItemDeliveryLocationQuery(
  options: Omit<Urql.UseQueryArgs<GetSharedLineItemDeliveryLocationQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    GetSharedLineItemDeliveryLocationQuery,
    GetSharedLineItemDeliveryLocationQueryVariables
  >({ query: GetSharedLineItemDeliveryLocationDocument, ...options });
}
